exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n  button img {\n    width: 2rem;\n    height: 2rem;\n    margin-right: 1rem; }\n\n.green {\n  color: green; }\n\n.red {\n  color: red; }\n\n.center {\n  margin: 1rem auto;\n  text-align: center; }\n\nheader {\n  margin-bottom: 2rem; }\n  header h4 {\n    color: #B9B9B9; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/user/user-login/user-login.component.scss
// module id = ../../../../../src/app/user/user-login/user-login.component.scss
// module chunks = main